import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import {TIME_FORMAT} from "config/constants";
import {AppData, Destination, Route} from "v2/api/Records";
import {formatTimeConstraints} from "v2/api/TimeConstraints";
import DestinationAddress from "v2/components/DestinationAddress";
import DestinationEstStartTime from "v2/components/DestinationEstStartTime";
import DestinationFlag from "v2/components/DestinationFlag";
import DestinationTitle from "v2/components/DestinationTitle";
import {
  CancelIcon,
  FirstMaiVisitIcon,
  NoVisitIcon,
  ReadOnlyIcon,
  RevisitIcon,
  SchedulerNotesIcon,
  TimeConstraintsIcon,
} from "v2/components/icons";
import styles from "v2/styles";

const DestinationSidebarLink = (props, context) => {
  const {
    appData,
    location: {query},
    params: {date, routeId},
    routeData: {readOnly},
    router,
  } = context;
  const {data, onMouseEnter, onMouseLeave} = props;

  const pathname = `/${date}/${routeId}/${data.id}`;
  const className = classnames("DestinationSidebarLink", {
    active: router.isActive(pathname, true),
  });

  const icons = [];
  let iconsContent;
  if (data.house && !data.visitTemplate) {
    icons.push(<NoVisitIcon key="NoVisitIcon" />);
  }
  if (data.isFirstMaiVisit) {
    icons.push(<FirstMaiVisitIcon key="FirstMaiVisitIcon" />);
  }
  if (data.isRevisit) {
    icons.push(<RevisitIcon key="RevisitIcon" />);
  }
  if (data.house && !data.house.timeConstraints.isEmpty()) {
    icons.push(
      <TimeConstraintsIcon
        key="TimeConstraintsIcon"
        title={formatTimeConstraints(data.house.timeConstraints)} />
    );
  }
  if (data.schedulerNotes) {
    icons.push(<SchedulerNotesIcon key="SchedulerNotesIcon" title={data.schedulerNotes} />);
  }
  if (readOnly) {
    icons.push(<ReadOnlyIcon key="ReadOnlyIcon" title="Destination can't be modified" />);
  }

  if (data.cancelReason) {
    const cancelMessage = `Cancelled, ${appData.cancelReason.get(data.cancelReason)}`;
    icons.push(<CancelIcon key="CancelIcon" title={cancelMessage} />);
  }
  if (icons.length) {
    iconsContent = (
      <span className="erg-block">
        {icons}
      </span>
    );
  }

  return (
    <div
      className={className}
      onClick={() => router.push({pathname, query})}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{borderBottom: styles.BORDER}}>
      <div className="DestinationSidebarLink-Time small">
        <small>Planned</small><br />
        <DestinationEstStartTime data={data} />
        <br />
        <span>to {data.estEndTime.format(TIME_FORMAT)}</span>
        <br /><br />
        <small>Actual</small><br />
        {data.checkinTime ? <strong>{data.checkinTime.format(TIME_FORMAT)}</strong> : "--"}
        <br />
        <span>to {data.checkoutTime ? data.checkoutTime.format(TIME_FORMAT) : "--"}</span>
      </div>
      <div className="DestinationSidebarLink-Title">
        <DestinationTitle data={data} sidebar />
        <DestinationFlag data={data} sidebar /><br />
        <DestinationAddress className="text-muted" data={data} sidebar />
        <div className="erg-margin-top-10">{iconsContent}</div>
      </div>
    </div>
  );
};

DestinationSidebarLink.contextTypes= {
  appData: PropTypes.instanceOf(AppData),
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
  routeData: PropTypes.instanceOf(Route).isRequired,
};
DestinationSidebarLink.propTypes = {
  data: PropTypes.instanceOf(Destination).isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

export default DestinationSidebarLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DestinationSidebarLink.js
 **/